import {ProductOptionValueType} from "../../definitions/types";
import {ImageModel} from "../domain/imageModel";

import {ProductOptionValueItemModel} from "./productOptionValueItemModel";

export class ProductOptionValueModel {
    private readonly _optionValue: ProductOptionValueType;

    /**
     * @constructor
     * @param optionValue {ProductOptionValueType}
     * @description Creates a new instance of the ProductOptionValueModel class.
     */
    constructor(public readonly optionValue: ProductOptionValueType) {
        this._optionValue = optionValue;
    }

    /**
     * @method id
     * @description Returns the ID of the value for the option.
     * @returns {number}
     */
    public get attributeId(): number {
        return this._optionValue.productAttributeTypeId;
    }

    /**
     * @method id
     * @description Returns the ID of the value for the option.
     * @returns {number}
     */
    public get value(): string {
        return this._optionValue.value;
    }

    /**
     * @method active
     * @description Returns whether the option value is active.
     * @returns {boolean}
     */
    public get active(): boolean {
        return this._optionValue.isActive;
    }

    /**
     * @method available
     * @description Returns whether the option value is available.
     * @returns {boolean}
     */
    public get available(): boolean {
        return this._optionValue.isAvailable;
    }

    /**
     * @method disabled
     * @description Returns whether the option value is disabled, which is the opposite of available.
     * @returns {boolean}
     */
    public get disabled(): boolean {
        return !this._optionValue.isAvailable;
    }

    /**
     * @method image
     * @description Returns the image for the option value.
     * @returns {ImageModel | undefined}
     */
    public get image(): ImageModel | undefined {
        return this._optionValue.thumbnailImage ? new ImageModel(this._optionValue.thumbnailImage) : undefined;
    }

    /**
     * @method items
     * @description Returns the items for the option value.
     * @returns {ProductOptionValueItemModel[]}
     */
    public get items(): ProductOptionValueItemModel[] {
        return this._optionValue.items.map((productOptionValueItem) => new ProductOptionValueItemModel(productOptionValueItem));
    }
}